import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { graphql } from 'app/generated/gql'
import { notifySuccess } from 'app/services/notify.client'
import { logError } from 'lib/logging'
import { useCallStore } from 'app/stores/StoreContext'
import { gqlQuery } from 'app/lib/graphqlClient'

const CALL_TRANSCRIPTION_QUERY = graphql(`
  query CallTranscription($id: ID!) {
    callTranscription(id: $id)
  }
`)

export type AiField = {
  appointmentDate?: string
  appointmentTime?: string
  callerPhone?: string
  patientName?: string
  patientBirthdate?: string
  treatment?: string
  newPatient?: string
  insuranceProvider?: string
  patientScheduled?: string
  callOutcome?: string
  staff?: string
  referral?: string
}

export type CallDataExtractionSlugData = {
  transcription: string | null
  call: { id: string; callDate: string; waveforms?: any; recordingDuration?: number; aiFields?: AiField[] }
  loading: boolean
}

export type UseCallDataExtractionSlugReturn = {
  transcription: string | null
  call: CallDataExtractionSlugData['call']
  loading: boolean
  onSubmit: () => void
}

export function useCallDataExtractionSlug(): UseCallDataExtractionSlugReturn {
  const { slug } = useParams()
  const [data, setData] = useState<CallDataExtractionSlugData>({
    transcription: null,
    call: { id: ``, callDate: `` },
    loading: true,
  })
  const callStore = useCallStore()

  useEffect(() => {
    if (!slug) return

    // Fetch the call record
    callStore
      .fetchOne(slug)
      .then((result) => {
        const call = (result.data as any)?.call as CallDataExtractionSlugData['call'] | undefined
        if (call) setData((prev) => ({ ...prev, call, loading: false }))
        else setData((prev) => ({ ...prev, loading: false }))
      })
      .catch((err) => {
        logError(`Error fetching call data extraction`, err)
        setData((prev) => ({ ...prev, loading: false }))
      })

    // Fetch transcription separately
    gqlQuery<{ callTranscription: string | null }>(CALL_TRANSCRIPTION_QUERY, {
      id: slug,
    }).then((res) => {
      setData((prev) => ({ ...prev, transcription: res.data?.callTranscription ?? null }))
    })
  }, [slug])

  const onSubmit = () => notifySuccess(`Data Extraction Queued`)

  return { transcription: data.transcription, call: data.call, loading: data.loading, onSubmit }
}
